import * as React from 'react';

const Water = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={28} fill={color}>
    <path d="M10 27.133a9.938 9.938 0 0 0 7.071-2.966A10.19 10.19 0 0 0 20 17.007c0-2.792-1.87-4.9-4.053-7.36C13.757 7.18 11.25 4.357 10 .133c0 0-10 9.595-10 16.875a10.19 10.19 0 0 0 2.929 7.16A9.938 9.938 0 0 0 10 27.132ZM7.743 7.973l1.18 1.195c-.483.49-1.88 2.212-3.178 4.843l-1.49-.756c1.367-2.77 2.862-4.646 3.488-5.282Z" />
  </svg>
);
export default Water;
